import { AlertTriangle, DollarSign, PiggyBank, TrendingUp, Wallet } from "lucide-react";
import { StatCard } from "@/components/ui/stat-card";
import type { BudgetSummary } from "@/lib/api/acquisitions";

type BudgetSummaryStripProps = {
  summary: BudgetSummary;
  formatCurrency: (n: number) => string;
};

export function BudgetSummaryStrip({ summary, formatCurrency }: BudgetSummaryStripProps) {
  const utilizationHigh = summary.utilizationPercent > 80;

  return (
    <div className="grid grid-cols-2 gap-2 lg:grid-cols-4 lg:gap-3">
      <StatCard
        size="sm"
        icon={<DollarSign className="h-4 w-4" />}
        label="Total allocation"
        value={formatCurrency(summary.totalAllocation)}
      />
      <StatCard
        size="sm"
        icon={<PiggyBank className="h-4 w-4" />}
        label="Available"
        value={formatCurrency(summary.totalAvailable)}
        iconBg="bg-emerald-50 text-emerald-600"
      />
      <StatCard
        size="sm"
        icon={<TrendingUp className="h-4 w-4" />}
        label="Expended"
        value={formatCurrency(summary.totalExpended)}
        iconBg="bg-blue-50 text-blue-600"
      />
      <StatCard
        size="sm"
        icon={
          utilizationHigh ? <AlertTriangle className="h-4 w-4" /> : <Wallet className="h-4 w-4" />
        }
        label="Utilization"
        value={`${summary.utilizationPercent}%`}
        iconBg={
          summary.utilizationPercent > 90
            ? "bg-red-50 text-red-600"
            : summary.utilizationPercent > 70
              ? "bg-amber-50 text-amber-600"
              : "bg-emerald-50 text-emerald-600"
        }
      />
    </div>
  );
}
